import styled from 'styled-components/macro';
import { Focusable } from 'components/navigation';
import scaleSize from 'utils/scale-size';

export const MIN_KEY_WIDTH = 90;
export const MARGIN_RIGHT = 10;

export const StyledKey = styled(Focusable)<{ span: number }>`
  width: ${({ span = 1 }) =>
    scaleSize(MIN_KEY_WIDTH * span + MARGIN_RIGHT * span - MARGIN_RIGHT)}px;
  height: ${scaleSize(60)}px;
  line-height: ${scaleSize(60)}px;
  text-align: center;
  border-radius: ${scaleSize(8)}px;
  background: ${({ theme }) => theme.backgroundColor};
  color: ${({ disabled, theme }) => (disabled ? theme.backgroundColor : theme.mainTextColor)};
  font-family: 'RobotoRegular', sans-serif;
  font-size: 40px;
  display: inline-block;
  font-weight: normal;
  margin-right: ${scaleSize(MARGIN_RIGHT)}px;
  box-sizing: border-box;

  & > svg path {
    fill: ${({ theme }) => theme.mainTextColor};
  }

  &:focus {
    background: ${({ theme }) => theme.activeColor};

    & > svg path {
    }
  }
`;

export const Row = styled.div`
  margin-bottom: ${scaleSize(10)}px;
`;

export const StyledSearchQuery = styled('div')<{ isQuery: boolean }>`
  font-family: 'Roboto';
  font-weight: 500;
  font-size: ${scaleSize(48)}px;
  line-height: ${scaleSize(65)}px;
  width: ${scaleSize(600)}px;
  height: ${scaleSize(130)}px;
  margin-bottom: 42px;
  opacity: ${({ isQuery }) => (isQuery ? '1' : '0.5')};
`;
